// extracted by mini-css-extract-plugin
export default {"card":"Card_card__18EVw","card_header":"Card_card_header__q1DCH","title":"Card_title__-QpUW"};